import * as React from "react";
import { logger } from "bernie-core";
import { UitkHeading, UitkHeadingProps } from "uitk-react-text";
import { CTACarouselRegionProps } from "./typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { IsomorphicCarousel } from "components/shared/IsomorphicCarousel/IsomorphicCarousel";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";

@logger("CTACarouselRegion")
export class CTACarouselRegion extends React.Component<CTACarouselRegionProps> {
  public render() {
    return <CtaCarouselComponent {...this.props} />;
  }
}

const CtaCarouselComponent = (props: CTACarouselRegionProps) => {
  const { flexComponent, context, l10n } = props;
  const { title, innerTitle, lg, md, sm, view } = flexComponent.model;
  const blossomComponent = BlossomComponentFactory.get(props as BlossomComponentFactoryProps);
  const name = flexComponent.name;
  const headingClass = "all-x-margin-three";
  let subheadingClass = "uitk-type-300 all-x-margin-three";
  let regionBottomPadding = "all-b-padding-six";
  let carouselClass = "all-t-margin-three all-b-margin-zero all-l-margin-three";
  const moduleTypes = ["call-to-action", "native-marquee-tile", "editorial"];
  let itemsVisible = {
    lg: lg || 6,
    md: md || 4,
    sm: sm || 3,
  };

  if (view === "lob-carousel") {
    itemsVisible = {
      lg: lg || 5,
      md: md || 4,
      sm: sm || 2,
    };
    subheadingClass = "uitk-type-300 all-t-margin-zero all-x-margin-three";
    regionBottomPadding = "s-b-padding-three all-b-padding-zero";
    carouselClass = "all-b-margin-zero all-l-margin-three";
  }
  const className = `CTACarouselRegion uitk-cell all-cell-1-1 all-t-padding-three ${regionBottomPadding} ${name} `;

  if (!flexComponent || !flexComponent.model || flexComponent.model.mobileWidth === "hidden" || !blossomComponent) {
    return null;
  }

  const children = blossomComponent.renderChildren(props.logger, l10n, context, (module) =>
    moduleTypes.includes(module.name)
  );

  if (children.length < 1) {
    return null;
  }

  const keyHelper = new ItemKeyHelper(props.flexComponent.id);
  const { formatText } = props.l10n;
  const headingConfig: UitkHeadingProps = { level: 2, size: 700 };

  return (
    <div className={className} data-testid="cta-carousel-region" id={flexComponent.id}>
      {title && (
        <div className={headingClass}>
          <UitkHeading {...headingConfig}>{title}</UitkHeading>
        </div>
      )}
      {innerTitle && <p className={subheadingClass}>{innerTitle}</p>}
      <IsomorphicCarousel
        className={carouselClass}
        itemsVisible={itemsVisible}
        buttonText={{
          nextButton: formatText("carousel.item.next"),
          prevButton: formatText("carousel.item.prev"),
        }}
        pageBy={1}
        peekWidth={12}
        wrapItems={false}
      >
        {children.map((child) => (
          <li key={keyHelper.next()}>{child}</li>
        ))}
      </IsomorphicCarousel>
    </div>
  );
};

export default CTACarouselRegion;
